var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g2, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeat5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 62,
    viewBox: "0 0 82 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 82,
    height: 62
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.1245 0H2.87547C1.28739 0 0 1.28739 0 2.87547V59.1245C0 60.7126 1.28739 62 2.87547 62H79.1245C80.7126 62 82 60.7126 82 59.1245V2.87547C82 1.28739 80.7126 0 79.1245 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_2)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 31C72 13.8792 58.1208 0 41 0C23.8792 0 10 13.8792 10 31C10 48.1208 23.8792 62 41 62C58.1208 62 72 48.1208 72 31Z",
    fill: "url(#paint0_linear_5_2)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 0,
    width: 63,
    height: 62
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3085 0H10V62H72.3085V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1571 55.1147C56.2392 55.1147 69.2762 54.7591 69.2762 54.3205C69.2762 53.8819 56.2392 53.5264 40.1571 53.5264C24.0751 53.5264 11.0381 53.8819 11.0381 54.3205C11.0381 54.7591 24.0751 55.1147 40.1571 55.1147Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4848 38.1822C18.4848 38.1822 15.0687 33.0901 10.0028 33.7446L16.774 38.9125C16.774 38.9125 12.9947 36.3299 9.37695 40.3269C9.37695 40.3269 14.3696 39.527 16.936 41.0159C16.936 41.0159 18.5309 42.4831 19.0299 42.4019C22.0699 41.9073 18.4848 38.1822 18.4848 38.1822Z",
    fill: "#268334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1825 44.4336H45.7239L47.1778 51.0469H35.5469L37.1825 44.4336Z",
    fill: "#A8A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2695 42.3589C17.2687 43.0115 17.3711 43.658 17.5708 44.2611C17.7705 44.8643 18.0636 45.4123 18.4332 45.8738C18.8029 46.3352 19.2419 46.7011 19.725 46.9504C20.2082 47.1997 20.726 47.3275 21.2488 47.3265H61.058C62.1134 47.3258 63.1255 46.8023 63.8719 45.8709C64.6184 44.9395 65.0383 43.6764 65.0394 42.3589V40.2998H17.2695V42.3589Z",
    fill: "#A8A9AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4623 51.46H32.8467",
    stroke: "url(#paint1_linear_5_2)",
    strokeWidth: 1.69967,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2695 41.3257C17.2687 41.9783 17.3711 42.6248 17.5708 43.2279C17.7705 43.8311 18.0636 44.3791 18.4332 44.8406C18.8029 45.302 19.2419 45.6679 19.725 45.9172C20.2082 46.1665 20.726 46.2943 21.2488 46.2933H61.058C62.1134 46.2926 63.1255 45.7691 63.8719 44.8377C64.6184 43.9063 65.0383 42.6432 65.0394 41.3257V39.2666H17.2695V41.3257Z",
    fill: "url(#paint2_linear_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0582 10.127H21.2507C20.1948 10.127 19.1822 10.5347 18.4356 11.2605C17.689 11.9863 17.2695 12.9708 17.2695 13.9972V39.4736H65.0394V13.9972C65.0388 12.9709 64.6192 11.9868 63.8727 11.2611C63.1262 10.5354 62.1139 10.1275 61.0582 10.127Z",
    fill: "url(#paint3_linear_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3614 43.607C42.0496 43.607 42.6076 43.0518 42.6076 42.367C42.6076 41.6821 42.0496 41.127 41.3614 41.127C40.6732 41.127 40.1152 41.6821 40.1152 42.367C40.1152 43.0518 40.6732 43.607 41.3614 43.607Z",
    fill: "#6D6F75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3614 43.607C42.0496 43.607 42.6076 43.0518 42.6076 42.367C42.6076 41.6821 42.0496 41.127 41.3614 41.127C40.6732 41.127 40.1152 41.6821 40.1152 42.367C40.1152 43.0518 40.6732 43.607 41.3614 43.607Z",
    fill: "url(#paint4_linear_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8462 11.3662H22.4612C20.3978 11.3662 18.7227 13.0131 18.7227 15.0449V39.2662H63.5847V15.0449C63.5929 13.0131 61.9198 11.3662 59.8462 11.3662Z",
    fill: "url(#paint5_linear_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8462 11.3662H22.4612C20.3978 11.3662 18.7227 13.0131 18.7227 15.0449V39.2662H63.5847V15.0449C63.5929 13.0131 61.9198 11.3662 59.8462 11.3662Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4494 16.1201H25.843C24.8931 16.1201 24.123 16.9662 24.123 18.01V23.7369C24.123 24.7807 24.8931 25.6268 25.843 25.6268H34.4494C35.3993 25.6268 36.1693 24.7807 36.1693 23.7369V18.01C36.1693 16.9662 35.3993 16.1201 34.4494 16.1201Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3064 16.1201H41.732C41.1832 16.1201 40.7383 16.5456 40.7383 17.0704V17.8565C40.7383 18.3813 41.1832 18.8068 41.732 18.8068H60.3064C60.8552 18.8068 61.3001 18.3813 61.3001 17.8565V17.0704C61.3001 16.5456 60.8552 16.1201 60.3064 16.1201Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3064 22.7334H41.732C41.1832 22.7334 40.7383 23.1916 40.7383 23.7568V24.6033C40.7383 25.1685 41.1832 25.6267 41.732 25.6267H60.3064C60.8552 25.6267 61.3001 25.1685 61.3001 24.6033V23.7568C61.3001 23.1916 60.8552 22.7334 60.3064 22.7334Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3016 28.9336H24.4989C23.9472 28.9336 23.5 29.3591 23.5 29.8839V30.67C23.5 31.1948 23.9472 31.6203 24.4989 31.6203H60.3016C60.8533 31.6203 61.3005 31.1948 61.3005 30.67V29.8839C61.3005 29.3591 60.8533 28.9336 60.3016 28.9336Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7546 24.9935L33.366 21.0665C33.2954 20.9518 33.1965 20.8555 33.0781 20.7861C32.9597 20.7167 32.8255 20.6762 32.6871 20.6684C32.5486 20.6606 32.4104 20.6855 32.2843 20.7411C32.1583 20.7966 32.0484 20.8811 31.9642 20.9871L29.9282 23.582L28.5624 22.1562C28.4811 22.0712 28.3823 22.0033 28.2723 21.9569C28.1623 21.9105 28.0435 21.8865 27.9234 21.8865C27.8033 21.8865 27.6845 21.9105 27.5745 21.9569C27.4645 22.0033 27.3658 22.0712 27.2845 22.1562L24.5391 25.0536C24.6992 25.2335 24.898 25.3779 25.1217 25.4769C25.3454 25.5758 25.5888 25.6271 25.835 25.627H34.4015C34.6623 25.6277 34.9199 25.571 35.1544 25.4612C35.389 25.3514 35.5943 25.1915 35.7546 24.9935Z",
    fill: "#195723",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8236 19.22C27.3972 19.22 27.8621 18.7573 27.8621 18.1867C27.8621 17.616 27.3972 17.1533 26.8236 17.1533C26.2501 17.1533 25.7852 17.616 25.7852 18.1867C25.7852 18.7573 26.2501 19.22 26.8236 19.22Z",
    fill: "#195723",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1543 26.6598C14.3194 26.6593 14.4776 26.5957 14.5944 26.4827C14.7111 26.3698 14.7769 26.2167 14.7774 26.057V25.4026C14.7769 25.2429 14.7111 25.0898 14.5944 24.9769C14.4776 24.8639 14.3194 24.8003 14.1543 24.7998C13.9892 24.8003 13.831 24.8639 13.7143 24.9769C13.5976 25.0898 13.5317 25.2429 13.5312 25.4026V26.057C13.5317 26.2167 13.5976 26.3698 13.7143 26.4827C13.831 26.5957 13.9892 26.6593 14.1543 26.6598Z",
    fill: "#6A7BEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0235 26.6602C16.1886 26.6597 16.3468 26.6031 16.4635 26.5026C16.5803 26.4021 16.6461 26.2659 16.6466 26.1237V25.5433C16.6461 25.4011 16.5803 25.2649 16.4635 25.1644C16.3468 25.0639 16.1886 25.0073 16.0235 25.0068C15.8584 25.0073 15.7002 25.0639 15.5834 25.1644C15.4667 25.2649 15.4009 25.4011 15.4004 25.5433V26.1237C15.4009 26.2659 15.4667 26.4021 15.5834 26.5026C15.7002 26.6031 15.8584 26.6597 16.0235 26.6602Z",
    fill: "#6A7BEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.343 25.6266H21.196C21.3663 25.6261 21.5295 25.5567 21.65 25.4335C21.7704 25.3102 21.8383 25.1432 21.8388 24.969V24.4242C21.8388 24.2498 21.7711 24.0825 21.6505 23.9592C21.53 23.8359 21.3665 23.7666 21.196 23.7666H13.343C13.1726 23.7671 13.0094 23.8365 12.889 23.9598C12.7685 24.083 12.7007 24.25 12.7002 24.4242V24.969C12.7002 25.1434 12.7679 25.3107 12.8885 25.434C13.009 25.5573 13.1725 25.6266 13.343 25.6266Z",
    fill: "url(#paint6_linear_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2328 32.4463H26.7481C24.4952 32.4463 22.6689 34.2726 22.6689 36.5255V52.7538C22.6689 55.0067 24.4952 56.833 26.7481 56.833H33.2328C35.4857 56.833 37.312 55.0067 37.312 52.7538V36.5255C37.312 34.2726 35.4857 32.4463 33.2328 32.4463Z",
    fill: "url(#paint7_linear_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3279 33.3662H26.6532C24.9636 33.3662 23.5938 34.7359 23.5938 36.4256V52.853C23.5938 54.5426 24.9636 55.9124 26.6532 55.9124H33.3279C35.0176 55.9124 36.3873 54.5426 36.3873 52.853V36.4256C36.3873 34.7359 35.0176 33.3662 33.3279 33.3662Z",
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8443 41.6435C31.0142 41.7832 29.9379 40.9199 29.9379 40.9199C29.9379 40.9199 29.0179 41.8535 27.0316 41.6435C27.0316 41.6435 26.8772 45.32 29.9379 46.7066C33.0033 45.32 32.8443 41.6435 32.8443 41.6435Z",
    fill: "#77B280"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.938 40.9199C29.938 40.9199 29.0107 41.8037 27.0304 41.6702C27.0304 41.6702 26.9621 45.3378 29.938 46.7066",
    fill: "url(#paint8_linear_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6924 43.657L29.6023 44.433L31.1847 42.9863",
    stroke: "white",
    strokeWidth: 0.339933,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7597 34.1597L26.1965 33.4592C26.0177 33.2367 26.176 32.9062 26.4614 32.9062H33.3659C33.6514 32.9062 33.8097 33.2367 33.6309 33.4592L33.0677 34.1597C33.0032 34.2399 32.9057 34.2866 32.8028 34.2866H27.0246C26.9216 34.2866 26.8242 34.2399 26.7597 34.1597Z",
    fill: "url(#paint9_linear_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.859 45.8688C61.2184 46.6146 61.2585 50.4136 61.4901 51.7029C61.5983 52.3021 61.2099 54.4596 60.8868 54.983C60.78 55.156 59.303 55.0513 59.1029 55.0843C58.2558 55.2246 54.2515 55.282 53.7297 54.7418C53.2079 54.2016 54.6602 52.9035 54.5601 52.2682C54.0343 48.9299 56.0651 45.7197 56.0651 45.7197C56.0651 45.7197 58.3865 45.0615 59.859 45.8688Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9395 53.402C56.9395 53.402 59.1079 52.9915 59.719 50.1042C59.9738 48.9016 59.8217 48.0453 60.0515 47.9628C60.4791 47.8104 61.1077 48.7621 61.1077 48.7621C61.1077 48.7621 61.7135 51.7743 61.4359 52.687C61.1583 53.5996 57.3721 54.1463 57.3721 54.1463L56.9395 53.402Z",
    fill: "#B97B1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0927 45.6738C56.0927 45.6738 53.5908 45.9143 51.9541 50.4999L53.6287 50.8405L56.108 48.8773L56.0927 45.6738Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.2589 56.8331C57.2589 56.8331 59.1325 56.7296 59.0107 56.1071C58.8889 55.4846 56.9395 56.0005 56.9395 56.0005L57.2589 56.8331Z",
    fill: "#1F1406"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5243 44.4133C56.5243 44.4133 56.6898 45.3045 56.8266 46.0429C56.8446 46.1395 56.8892 46.2297 56.9558 46.3045C57.0225 46.3793 57.1088 46.4358 57.206 46.4684C57.3031 46.5009 57.4077 46.5083 57.5088 46.4898C57.61 46.4713 57.7042 46.4275 57.7817 46.363L57.9313 46.237C58.0374 46.1486 58.1148 46.0334 58.1546 45.9047C58.1945 45.7761 58.1951 45.6393 58.1564 45.5103L57.5827 43.6064L56.5234 44.4124L56.5243 44.4133Z",
    fill: "#E0885C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.5243 44.4133C56.5243 44.4133 56.6898 45.3045 56.8266 46.0429C56.8446 46.1395 56.8892 46.2297 56.9558 46.3045C57.0225 46.3793 57.1088 46.4358 57.206 46.4684C57.3031 46.5009 57.4077 46.5083 57.5088 46.4898C57.61 46.4713 57.7042 46.4275 57.7817 46.363L57.9313 46.237C58.0374 46.1486 58.1148 46.0334 58.1546 45.9047C58.1945 45.7761 58.1951 45.6393 58.1564 45.5103L57.5827 43.6064L56.5234 44.4124L56.5243 44.4133Z",
    fill: "url(#paint10_linear_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9521 43.1934C55.9521 43.1934 55.3235 43.6359 56.0222 44.1244C56.7208 44.6129 55.9521 43.1934 55.9521 43.1934Z",
    fill: "#1F1406"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9194 43.5932C55.8963 43.6966 55.8942 43.8037 55.9132 43.9079L55.9262 43.9788C55.9643 44.1848 56.0036 44.3979 56.0372 44.5834C56.0635 44.7277 56.143 44.8563 56.2595 44.9427C56.376 45.0292 56.5205 45.067 56.6635 45.0483L57.0849 44.9938C57.1587 44.9842 57.2297 44.9593 57.2937 44.9208C57.3577 44.8822 57.4133 44.8308 57.4571 44.7696C57.5009 44.7084 57.532 44.6387 57.5484 44.5649C57.5649 44.491 57.5663 44.4145 57.5527 44.3401C57.5448 44.2967 57.5366 44.252 57.5283 44.2064C57.5672 44.2188 57.6107 44.2259 57.6566 44.2264C57.8282 44.2283 57.9697 44.1378 57.9772 44.0238C57.9847 43.9099 57.8476 43.8154 57.676 43.8131C57.5958 43.8121 57.5222 43.8314 57.4656 43.8639C57.4509 43.7834 57.4363 43.7033 57.422 43.6257C57.3859 43.4293 57.2775 43.2543 57.1189 43.1366C56.9602 43.0189 56.7634 42.9674 56.5687 42.9926C56.4654 43.0061 56.3659 43.0409 56.2763 43.0948C56.1866 43.1488 56.1087 43.2209 56.0474 43.3065C55.986 43.3922 55.9425 43.4898 55.9194 43.5932Z",
    fill: "#E0885C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9194 43.5932C55.8963 43.6966 55.8942 43.8037 55.9132 43.9079L55.9262 43.9788C55.9643 44.1848 56.0036 44.3979 56.0372 44.5834C56.0635 44.7277 56.143 44.8563 56.2595 44.9427C56.376 45.0292 56.5205 45.067 56.6635 45.0483L57.0849 44.9938C57.1587 44.9842 57.2297 44.9593 57.2937 44.9208C57.3577 44.8822 57.4133 44.8308 57.4571 44.7696C57.5009 44.7084 57.532 44.6387 57.5484 44.5649C57.5649 44.491 57.5663 44.4145 57.5527 44.3401C57.5448 44.2967 57.5366 44.252 57.5283 44.2064C57.5672 44.2188 57.6107 44.2259 57.6566 44.2264C57.8282 44.2283 57.9697 44.1378 57.9772 44.0238C57.9847 43.9099 57.8476 43.8154 57.676 43.8131C57.5958 43.8121 57.5222 43.8314 57.4656 43.8639C57.4509 43.7834 57.4363 43.7033 57.422 43.6257C57.3859 43.4293 57.2775 43.2543 57.1189 43.1366C56.9602 43.0189 56.7634 42.9674 56.5687 42.9926C56.4654 43.0061 56.3659 43.0409 56.2763 43.0948C56.1866 43.1488 56.1087 43.2209 56.0474 43.3065C55.986 43.3922 55.9425 43.4898 55.9194 43.5932Z",
    fill: "url(#paint11_linear_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.586 43.3749C56.586 43.3749 55.1039 43.5526 55.2942 42.9678C55.4703 42.425 56.7775 43.2561 56.9389 43.0302L56.586 43.3749Z",
    fill: "#1F1406"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9209 52.6445C54.9209 52.6445 51.8725 51.051 50.9887 53.219C50.2315 55.0752 55.6032 56.4607 57.1586 56.8199C57.2756 56.8469 57.3982 56.8332 57.5063 56.7812C57.6145 56.7291 57.7017 56.6418 57.7537 56.5335L58.393 55.2027L54.9209 52.6445Z",
    fill: "#268334"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2131 55.9365C59.2131 55.9365 62.5061 54.8198 61.5382 52.6724C60.5702 50.5249 54.2393 54.9078 54.2393 54.9078L54.7679 56.3003C54.8097 56.4103 54.8888 56.5024 54.9916 56.5606C55.0944 56.6188 55.2144 56.6395 55.3309 56.6191L59.2131 55.9365Z",
    fill: "#268334"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7443 55.7998C54.7443 55.7998 53.0705 55.9768 53.2083 56.5668C53.3461 57.1569 55.0694 56.5822 55.0694 56.5822L54.7443 55.7998Z",
    fill: "#1F1406"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1262 50.4665C58.3468 49.4012 56.1386 49.2061 56.1386 49.2061L56.141 49.2135C55.789 49.2207 55.4567 49.6269 55.4567 49.6269C55.4567 49.6269 55.2407 50.4636 55.6776 50.6996C55.9174 50.8291 56.2662 50.5424 56.4596 50.1854C56.5293 50.2384 58.5727 51.7904 58.9149 51.8169C59.263 51.8438 59.9055 51.5318 59.1262 50.4665Z",
    fill: "#E0885C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1262 50.4665C58.3468 49.4012 56.1386 49.2061 56.1386 49.2061L56.141 49.2135C55.789 49.2207 55.4567 49.6269 55.4567 49.6269C55.4567 49.6269 55.2407 50.4636 55.6776 50.6996C55.9174 50.8291 56.2662 50.5424 56.4596 50.1854C56.5293 50.2384 58.5727 51.7904 58.9149 51.8169C59.263 51.8438 59.9055 51.5318 59.1262 50.4665Z",
    fill: "url(#paint12_linear_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5867 45.6738C59.5867 45.6738 61.6857 46.2247 61.7162 49.8047C61.7467 53.3847 58.1855 51.2322 58.1855 51.2322L58.3968 49.9214L58.7013 49.8983C58.8648 49.886 59.0243 49.8422 59.1704 49.7693C59.3166 49.6964 59.4465 49.5959 59.5527 49.4737C59.6588 49.3514 59.7392 49.2097 59.789 49.0569C59.8389 48.9041 59.8572 48.7432 59.8431 48.5834L59.5867 45.6738Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6844 51.4602L54.9397 51.4404C54.6367 51.4324 54.3254 51.2033 54.247 50.9342L53.6349 48.8393C53.5552 48.5681 53.7379 48.3526 54.0401 48.3606L54.7847 48.3808C55.0878 48.3888 55.3995 48.6179 55.4774 48.887L56.09 50.9814C56.1692 51.2514 55.987 51.4669 55.6844 51.4602Z",
    fill: "#1F1406"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0067 49.392C54.6612 48.8214 53.6757 49.6146 53.6757 49.6146C53.6676 49.6153 51.5761 49.7872 51.7243 50.4786C51.8728 51.1715 52.547 51.9268 54.1057 50.4521C54.1057 50.4522 54.1058 50.4521 54.1057 50.4521C54.1061 50.4522 54.1066 50.452 54.107 50.4521C54.4611 50.5221 55.3522 49.9627 55.0067 49.392Z",
    fill: "#E0885C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.0067 49.392C54.6612 48.8214 53.6757 49.6146 53.6757 49.6146C53.6676 49.6153 51.5761 49.7872 51.7243 50.4786C51.8728 51.1715 52.547 51.9268 54.1057 50.4521C54.1057 50.4522 54.1058 50.4521 54.1057 50.4521C54.1061 50.4522 54.1066 50.452 54.107 50.4521C54.4611 50.5221 55.3522 49.9627 55.0067 49.392Z",
    fill: "url(#paint13_linear_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.965 9.51078C60.3948 9.71359 60.909 9.53017 61.1135 9.10112L61.8721 7.50911C62.134 6.95942 62.6068 6.53678 63.1864 6.33417C63.766 6.13156 64.4049 6.16557 64.9626 6.42871C65.5204 6.69186 65.9512 7.16259 66.1603 7.73734C66.3695 8.3121 66.3398 8.94381 66.0779 9.49349L65.3193 11.0855C65.1148 11.5146 65.2975 12.0268 65.7274 12.2296C66.1572 12.4324 66.6714 12.249 66.8759 11.8199L67.6345 10.2279C68.0903 9.27135 68.1419 8.17206 67.7779 7.17186C67.414 6.17167 66.6642 5.3525 65.6937 4.89458C64.7231 4.43665 63.6112 4.37747 62.6026 4.73006C61.594 5.08265 60.7713 5.81812 60.3155 6.77468L59.5569 8.36669C59.3524 8.79575 59.5351 9.30798 59.965 9.51078Z",
    fill: "url(#paint14_linear_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1422 19.473L55.9635 16.086C55.5467 15.8894 55.2256 15.5359 55.0708 15.1034C54.916 14.6709 54.9401 14.1948 55.1378 13.7798L57.6506 8.5066C57.7485 8.30105 57.8861 8.11668 58.0555 7.96403C58.225 7.81138 58.4229 7.69343 58.6381 7.61693C58.8533 7.54043 59.0815 7.50686 59.3096 7.51816C59.5378 7.52945 59.7614 7.58539 59.9678 7.68276L67.1465 11.0698C67.3529 11.1671 67.538 11.304 67.6913 11.4726C67.8445 11.6413 67.9628 11.8383 68.0395 12.0525C68.1162 12.2668 68.1498 12.4939 68.1382 12.7211C68.1267 12.9483 68.0703 13.171 67.9723 13.3766L65.4595 18.6497C65.3616 18.8552 65.2239 19.0396 65.0545 19.1922C64.885 19.3448 64.687 19.4627 64.4718 19.5391C64.2566 19.6156 64.0284 19.6491 63.8003 19.6378C63.5721 19.6264 63.3485 19.5704 63.1422 19.473Z",
    fill: "url(#paint15_linear_5_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1775 11.0843L65.3408 10.2178C65.5432 10.3133 65.7243 10.4483 65.8738 10.6152C66.0233 10.7821 66.1383 10.9775 66.2121 11.1904C66.286 11.4033 66.3172 11.6294 66.3042 11.8558C66.2911 12.0822 66.2339 12.3045 66.136 12.5101L63.6232 17.7832C63.4254 18.1982 63.0734 18.5196 62.6446 18.6768C62.2157 18.8339 61.7452 18.8138 61.3365 18.621L63.1731 19.4875C63.3755 19.5831 63.5952 19.6372 63.8197 19.6468C64.0441 19.6564 64.269 19.6213 64.4814 19.5436C64.6937 19.4658 64.8895 19.3468 65.0574 19.1935C65.2254 19.0402 65.3622 18.8555 65.4602 18.6499L67.973 13.3768C68.071 13.1712 68.1281 12.9489 68.1412 12.7224C68.1543 12.496 68.1229 12.2698 68.0491 12.0569C67.9752 11.8441 67.8602 11.6486 67.7106 11.4817C67.5611 11.3148 67.3799 11.1798 67.1775 11.0843Z",
    fill: "#195723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9221 13.7572C61.5728 13.8224 62.1555 13.3483 62.2236 12.6983C62.2916 12.0482 61.8193 11.4684 61.1685 11.4032C60.5178 11.338 59.9351 11.8121 59.867 12.4622C59.799 13.1122 60.2713 13.692 60.9221 13.7572Z",
    fill: "#195723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1116 12.3398C61.2606 12.4105 61.377 12.5338 61.4352 12.6827C61.4935 12.8316 61.489 12.9941 61.4227 13.1346L60.5923 14.8771C60.5251 15.0172 60.4015 15.1236 60.2487 15.173C60.0959 15.2224 59.9263 15.2109 59.7769 15.1408C59.6279 15.07 59.5117 14.9466 59.4535 14.7976C59.3953 14.6487 59.3999 14.4863 59.4663 14.3459L60.2967 12.6033C60.364 12.4634 60.4875 12.3571 60.6401 12.3078C60.7928 12.2584 60.9623 12.2699 61.1116 12.3398Z",
    fill: "#195723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4634 25.251C26.777 23.3554 25.4954 21.5643 23.6007 21.2505C21.706 20.9367 19.9158 22.219 19.6021 24.1146C19.2885 26.0102 20.5701 27.8013 22.4648 28.1151C24.3595 28.4289 26.1497 27.1466 26.4634 25.251Z",
    fill: "#6A7BEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1233 43.3093C57.1233 43.3093 57.1975 44.1318 57.8565 44.0066C57.8565 44.0066 58.0174 43.2156 57.9674 42.8386C57.8758 42.1378 56.4057 42.3156 55.8938 42.7343C55.3819 43.153 55.8644 43.6019 57.1233 43.3093Z",
    fill: "#1F1406"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_5_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 19,
    width: 24,
    height: 23
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4676 19.124H51.9502V41.6414H74.4676V19.124Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_5_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_5_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 21,
    width: 24,
    height: 19
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4686 21.2354H51.9512V39.5308H74.4686V21.2354Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_5_2)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2722 36.3047C59.2167 36.2217 59.196 36.1198 59.2147 36.0214C59.2334 35.923 59.2899 35.8361 59.3719 35.7798L60.6545 34.9001C60.695 34.8722 60.7407 34.8527 60.7887 34.8427C60.8367 34.8327 60.8862 34.8324 60.9344 34.8417C60.9825 34.8511 61.0284 34.87 61.0693 34.8973C61.1103 34.9246 61.1455 34.9598 61.173 35.0009C61.2006 35.042 61.2198 35.0881 61.2297 35.1368C61.2396 35.1854 61.2399 35.2355 61.2307 35.2842C61.2214 35.333 61.2028 35.3794 61.1758 35.4209C61.1488 35.4623 61.1141 35.498 61.0735 35.5259L59.7909 36.4056C59.7503 36.4335 59.7047 36.453 59.6566 36.463C59.6086 36.473 59.5591 36.4734 59.5109 36.464C59.4627 36.4546 59.4169 36.4358 59.3759 36.4084C59.335 36.3811 59.2997 36.3459 59.2722 36.3047Z",
    fill: "#CCDEFA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8659 38.1874L56.4657 37.7761C56.5477 37.7198 56.6483 37.6988 56.7456 37.7177C56.8428 37.7366 56.9287 37.7939 56.9843 37.8768C57.0398 37.9598 57.0606 38.0618 57.0419 38.1602C57.0232 38.2587 56.9667 38.3456 56.8847 38.4019L56.285 38.8132C56.203 38.8694 56.1023 38.8904 56.005 38.8715C55.9078 38.8526 55.8219 38.7953 55.7664 38.7124C55.7108 38.6294 55.6901 38.5274 55.7087 38.429C55.7274 38.3305 55.784 38.2436 55.8659 38.1874Z",
    fill: "#CCDEFA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9128 38.8397L55.0586 38.7399C55.0991 38.7121 55.1448 38.6926 55.1928 38.6826C55.2408 38.6726 55.2903 38.6722 55.3385 38.6816C55.3866 38.6909 55.4325 38.7098 55.4734 38.7371C55.5144 38.7644 55.5496 38.7996 55.5771 38.8407C55.6047 38.8818 55.6239 38.928 55.6338 38.9766C55.6437 39.0252 55.644 39.0753 55.6348 39.1241C55.6255 39.1728 55.6069 39.2193 55.5799 39.2607C55.5529 39.3022 55.5182 39.3379 55.4776 39.3657L55.3318 39.4655C55.2499 39.5217 55.1492 39.5427 55.0519 39.5238C54.9547 39.5049 54.8688 39.4477 54.8132 39.3647C54.7577 39.2817 54.737 39.1798 54.7556 39.0813C54.7743 38.9829 54.8308 38.8959 54.9128 38.8397Z",
    fill: "#4BBFD7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4744 35.8768C56.4189 35.7939 56.3982 35.692 56.4169 35.5936C56.4356 35.4952 56.4921 35.4083 56.574 35.3521L57.8566 34.4723C57.9386 34.4161 58.0393 34.3951 58.1365 34.414C58.2338 34.4329 58.3196 34.4901 58.3752 34.5731C58.4307 34.6561 58.4515 34.7581 58.4328 34.8565C58.4141 34.955 58.3576 35.0419 58.2756 35.0981L56.9936 35.9781C56.9529 36.006 56.9073 36.0256 56.8592 36.0356C56.811 36.0457 56.7614 36.046 56.7132 36.0366C56.665 36.0272 56.619 36.0082 56.5781 35.9808C56.5371 35.9534 56.5018 35.9181 56.4744 35.8768Z",
    fill: "#0048B6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0652 37.7588L53.6649 37.3473C53.7055 37.3195 53.7511 37.3 53.7991 37.29C53.8472 37.28 53.8967 37.2796 53.9448 37.289C53.993 37.2984 54.0388 37.3172 54.0798 37.3445C54.1207 37.3718 54.156 37.407 54.1835 37.4481C54.211 37.4892 54.2303 37.5354 54.2401 37.584C54.25 37.6326 54.2504 37.6828 54.2411 37.7315C54.2319 37.7803 54.2132 37.8267 54.1863 37.8681C54.1593 37.9096 54.1245 37.9453 54.0839 37.9731L53.4842 38.3846C53.4022 38.4409 53.3015 38.4618 53.2043 38.4429C53.107 38.424 53.0212 38.3668 52.9656 38.2838C52.91 38.2008 52.8893 38.0989 52.908 38.0004C52.9266 37.902 52.9832 37.8151 53.0652 37.7588Z",
    fill: "#30388E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1159 38.4108L52.2617 38.3112C52.3023 38.2834 52.3479 38.2639 52.3959 38.2539C52.4439 38.2439 52.4934 38.2435 52.5415 38.2529C52.5897 38.2622 52.6355 38.2811 52.6765 38.3084C52.7174 38.3357 52.7527 38.3708 52.7802 38.4119C52.8077 38.453 52.8269 38.4992 52.8368 38.5478C52.8467 38.5964 52.8471 38.6465 52.8378 38.6952C52.8286 38.744 52.81 38.7904 52.783 38.8318C52.756 38.8733 52.7213 38.909 52.6807 38.9368L52.535 39.0366C52.453 39.0929 52.3523 39.1138 52.255 39.0949C52.1578 39.076 52.0719 39.0188 52.0164 38.9358C51.9608 38.8528 51.9401 38.7509 51.9587 38.6524C51.9774 38.554 52.034 38.4671 52.1159 38.4108Z",
    fill: "#30388E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1593 37.3234L59.0784 30.6388L54.123 29.0497C53.1284 28.7308 53.121 27.3084 54.1126 26.9794L73.8276 21.2609C74.0891 21.1741 74.2997 21.4878 74.1235 21.7019L62.2826 37.9093C61.6191 38.7157 60.3267 38.3582 60.1593 37.3234Z",
    fill: "#0048B6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.08 30.639L53.7648 28.9348C52.8825 28.652 52.8761 27.3903 53.7555 27.0982L73.8886 21.2412C74.0048 21.2026 74.0788 21.365 73.9744 21.4295L59.08 30.639Z",
    fill: "url(#paint16_linear_5_2)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6321 26.8254L60.632 26.8254C59.2215 27.6181 58.7207 29.4041 59.5134 30.8147C60.3061 32.2252 62.0921 32.726 63.5026 31.9333L63.5027 31.9333C64.9132 31.1407 65.414 29.3546 64.6213 27.9441C63.8286 26.5335 62.0426 26.0327 60.6321 26.8254Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_5_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 26,
    width: 6,
    height: 7
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6321 26.8254L60.632 26.8254C59.2215 27.6181 58.7207 29.4041 59.5134 30.8147C60.3061 32.2252 62.0921 32.726 63.5026 31.9333L63.5027 31.9333C64.9132 31.1407 65.414 29.3546 64.6213 27.9441C63.8286 26.5335 62.0426 26.0327 60.6321 26.8254Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_5_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8187 26.9852C62.7828 26.9212 62.7247 26.8965 62.6557 26.9156C62.4045 26.9827 62.1578 27.0651 61.9169 27.1624C61.7441 27.2338 61.5721 27.309 61.4035 27.3899C61.3025 27.4383 61.2046 27.4931 61.1067 27.5479C61.0777 27.5641 61.0488 27.5803 61.0197 27.5963C60.8196 27.7059 60.6262 27.8274 60.4406 27.9603L60.4265 27.9705C60.3309 28.04 60.2352 28.1095 60.1423 28.1824C59.9768 28.3124 59.818 28.4505 59.6651 28.5953C59.6091 28.6484 59.5995 28.7069 59.638 28.7754L60.1048 29.606L60.2234 29.8191C60.3273 30.0046 60.4312 30.19 60.537 30.3746C60.5886 30.4661 60.6455 30.5546 60.7074 30.6394C60.8464 30.8267 61.0299 30.9563 61.2456 31.0395C61.4793 31.1291 61.7211 31.1866 61.9661 31.2284C62.2925 31.2829 62.6229 31.3066 62.953 31.2993C63.0841 31.2966 63.1843 31.2412 63.2524 31.1291L63.2883 31.0702C63.3322 30.9985 63.3761 30.9268 63.4169 30.8533C63.6185 30.4903 63.7797 30.1101 63.8814 29.7051C63.9205 29.55 63.9446 29.393 63.9361 29.2317C63.9246 29.018 63.8497 28.8231 63.747 28.6389C63.5218 28.2349 63.295 27.8318 63.0681 27.4287L62.8187 26.9852ZM61.2692 30.3825L61.0896 30.4835L60.2708 29.0266L60.4504 28.9256L61.2692 30.3825ZM61.3006 29.9622L61.4804 29.8612L61.0064 29.0179L60.8267 29.1189L61.3006 29.9622ZM61.9446 29.8017L61.7648 29.9028L61.1185 28.7526L61.2982 28.6516L61.9446 29.8017ZM62.3566 30.0731L62.5362 29.9721L61.4589 28.0551L61.2793 28.1561L62.3566 30.0731Z",
    fill: "#62AD56"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7121 37.4894L61.0206 31.2468L72.9979 22.2199C73.2593 22.0305 73.5736 22.3728 73.3679 22.6229L62.159 38.0615C61.6555 38.6735 60.6722 38.2843 60.7121 37.4894Z",
    fill: "#4BBFD7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2761 36.0346L61.0204 31.2461L74.1541 21.3807C74.318 21.2618 74.533 21.4361 74.4532 21.6246L70.7617 35.5328C70.7033 35.6703 70.6167 35.7937 70.5078 35.895C70.3989 35.9963 70.2701 36.0731 70.1299 36.1205C69.9896 36.1679 69.8411 36.1847 69.6939 36.1699C69.5468 36.1551 69.4044 36.109 69.2761 36.0346Z",
    fill: "url(#paint17_linear_5_2)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_2",
    x1: 41,
    y1: 0,
    x2: 41,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_2",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C6C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_2",
    x1: 17.2695,
    y1: 42.7799,
    x2: 65.0394,
    y2: 42.7799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C6C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5_2",
    x1: 17.2695,
    y1: 24.8003,
    x2: 65.0394,
    y2: 24.8003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C6C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5_2",
    x1: 39.5614,
    y1: 42.2292,
    x2: 43.023,
    y2: 42.2292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C6C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5_2",
    x1: 18.7227,
    y1: 25.3162,
    x2: 63.5848,
    y2: 25.3162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55BC60",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291667,
    stopColor: "#55BC60",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B8C47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5_2",
    x1: 12.7002,
    y1: 24.6966,
    x2: 21.8388,
    y2: 24.6966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80ADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005AE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5_2",
    x1: 30.2617,
    y1: 32.4463,
    x2: 30.2617,
    y2: 56.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F0E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED1B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5_2",
    x1: 2755.29,
    y1: 1058.39,
    x2: 2849.39,
    y2: 1058.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#268334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195723"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5_2",
    x1: 30.0678,
    y1: 32.9063,
    x2: 30.0678,
    y2: 35.8395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F0E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED1B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5_2",
    x1: 56.5234,
    y1: 45.0531,
    x2: 58.185,
    y2: 45.0531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C6C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5_2",
    x1: 57.3544,
    y1: 44.0197,
    x2: 57.9775,
    y2: 44.0197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C6C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5_2",
    x1: 55.4033,
    y1: 50.5123,
    x2: 59.4956,
    y2: 50.5123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C6C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5_2",
    x1: 51.7168,
    y1: 50.2428,
    x2: 55.0849,
    y2: 50.2428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.411458,
    stopColor: "#E2E2E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5C6C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5_2",
    x1: 60.6104,
    y1: 6.15576,
    x2: 67.9161,
    y2: 9.63707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F0E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AED1B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5_2",
    x1: 56.3943,
    y1: 11.143,
    x2: 66.6971,
    y2: 16.0525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#268334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#41934D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#206D2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5_2",
    x1: 53.0995,
    y1: 25.9372,
    x2: 74.0244,
    y2: 25.9372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80ADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005AE4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5_2",
    x1: 61.0204,
    y1: 28.7585,
    x2: 74.4704,
    y2: 28.7585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80ADF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005AE4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeat5);
export default __webpack_public_path__ + "static/media/feat-5.bc89e666d3ef397ff06472e6c111fdab.svg";
export { ForwardRef as ReactComponent };